import { Button } from "@/components/ui/button";
import { CreditCard, Tag } from "lucide-react";
import { CashChangeCalculator, CustomerNifSection } from "./OrderDetailHelpers";

export function OrderPaymentSummary({
  order,
  formatPrice,
  setShowPaymentDialog,
  authAxios,
  onUpdate,
  handleDuplicate,
  handleCreateInvoice,
  handleViewInvoicePdf,
}) {
  return (
    <>
      <div>
        <h3 className="font-bold text-xs text-gray-500 uppercase tracking-wider mb-3">PAGAMENTO</h3>
        <div className="space-y-3">
          <div className="flex items-center justify-between gap-2">
            <div className="flex items-center gap-3 min-w-0">
              <div className={`text-white text-[10px] font-bold px-2 py-1 rounded uppercase shrink-0 ${
                (order.payment_method || "").toLowerCase().includes("visa") ? "bg-blue-700" :
                (order.payment_method || "").toLowerCase().includes("master") ? "bg-orange-600" :
                (order.payment_method || "").toLowerCase().includes("cash") || (order.payment_method || "").toLowerCase().includes("efectivo") || (order.payment_method || "").toLowerCase().includes("dinheiro") ? "bg-green-600" :
                (order.payment_method || "").toLowerCase().includes("online") ? "bg-purple-600" : "bg-gray-600"
              }`}>
                {(order.payment_method || "").toLowerCase().includes("visa") ? "VISA" :
                  (order.payment_method || "").toLowerCase().includes("master") ? "MC" :
                  (order.payment_method || "").toLowerCase().includes("cash") || (order.payment_method || "").toLowerCase().includes("efectivo") || (order.payment_method || "").toLowerCase().includes("dinheiro") ? "CASH" :
                    (order.payment_method || "").toLowerCase().includes("online") ? "ONLINE" :
                      (order.payment_method || "N/A").substring(0, 4).toUpperCase()}
              </div>
              <div className="min-w-0">
                <p className="text-xs text-gray-500 capitalize truncate">{order.payment_method || "Sin definir"}</p>
              </div>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <Tag className="w-4 h-4 text-emerald-500" /><span className="text-sm font-medium">{formatPrice(order.total)}</span>
            </div>
          </div>
          <CashChangeCalculator order={order} formatPrice={formatPrice} />
          <Button variant="outline" className="w-full border-emerald-300 text-emerald-700 font-bold uppercase tracking-wide hover:bg-emerald-50 text-xs h-9" onClick={() => setShowPaymentDialog(true)} data-testid="add-payment-btn">
            ALTERAR FORMA DE PAGAMENTO
          </Button>
        </div>
      </div>

      <CustomerNifSection order={order} authAxios={authAxios} onUpdate={onUpdate} />

      <div className="flex gap-2 flex-wrap">
        <Button variant="outline" size="sm" className="gap-1.5 text-xs text-purple-700 border-purple-300 hover:bg-purple-50 font-semibold" onClick={handleDuplicate} data-testid="duplicate-order-btn-body">DUPLICAR COMO NOVO</Button>
        <Button variant="outline" size="sm" className="gap-1.5 text-xs text-blue-700 border-blue-200 hover:bg-blue-50" onClick={handleCreateInvoice} data-testid="create-invoice-btn"><CreditCard className="w-3.5 h-3.5" />{order.vendus_invoice_number ? "VER FACTURA" : "FACTURA VENDUS"}</Button>
        {order.vendus_invoice_number && (
          <button onClick={handleViewInvoicePdf} className="inline-flex items-center gap-1 bg-emerald-100 hover:bg-emerald-200 text-emerald-700 text-xs font-medium px-2.5 py-1 rounded-full transition" data-testid="view-invoice-badge">
            Factura: {order.vendus_invoice_number}
          </button>
        )}
      </div>
    </>
  );
}
